import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, switchMap, tap } from "rxjs/operators";
import { AccountService } from "app/_services/account.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private readonly accountService: AccountService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap({
        error: (error) => {
          if (error instanceof HttpErrorResponse && error.status === 401) {
            // Optional: handle unauthorized (e.g., navigate, show toast, etc.)
          }
        },
      }),
      catchError((err) => {
        if (
          err instanceof HttpErrorResponse &&
          err.status === 401 &&
          !req.url.includes("RefreshAccessTokenWithRefreshToken")
        ) {
          let test = JSON.stringify(err);
          console.log(test);
          const errorReason = err.headers.get("X-Error-Reason");

          if (
            [
              "SessionMismatch",
              "UserNotFound",
              "IpMismatch",
              "UaMismatch",
              "TokenMissing",
            ].includes(errorReason ?? "")
          ) {
            console.warn("Critical session error:", errorReason);
            this.accountService.logout(true); // skip API call to revoke token
            return throwError(() => err);
          }

          const storedUser = JSON.parse(sessionStorage.getItem("user") || "{}");
          const userId = storedUser?.id;

          if (!userId) {
            this.accountService.logout(true);
            return throwError(() => err);
          }

          return this.accountService.refreshToken(userId).pipe(
            switchMap(() => next.handle(req)),
            catchError((refreshErr) => {
              this.accountService.logout(true);
              return throwError(() => refreshErr);
            })
          );
        }
         throw  err;
      })
    );
  }
}
